module.exports = __webpack_public_path__ + "img/321.558cb556.jpg";